export const getAvailableTransitAllowance = (): Array<{ label: string, value: string }> => {
    const travelAllowance = [
      { label: 'None', value: '0' },
      { label: '0.5 Hours', value: '0.5' },
      { label: '1 Hour', value: '1' },
      { label: '1.5 Hours', value: '1.5' },
      { label: '2 Hours', value: '2' },
      { label: '2.5 Hours', value: '2.5' },
      { label: '3 Hours', value: '3' },
      { label: '3.5 Hours', value: '3.5' },
      { label: '4 Hours', value: '4' },
      { label: '4.5 Hours', value: '4.5' },
      { label: '5 Hours', value: '5' },
      { label: '5.5 Hours', value: '5.5' },
      { label: '6 Hours', value: '6' },
      { label: '6.5 Hours', value: '6.5' },
      { label: '7 Hours', value: '7' },
      { label: '7.5 Hours', value: '7.5' },
      { label: '8 Hours', value: '8' },
      { label: '8.5 Hours', value: '8.5' },
      { label: '9 Hours', value: '9' },
      { label: '9.5 Hours', value: '9.5' },
      { label: '10 Hours', value: '10' }
    ];
    return travelAllowance;
  };

  
  export const getAvailableUnpaidBreak = (): Array<{ label: string, value: string }> => {
    const unpaidBreak = [
      { label: 'No Break', value: 'No break' },
      { label: '15 Minutes', value: '15 minutes' },
      { label: '30 Minutes', value: '30 minutes' },
      { label: '45 Minutes', value: '45 minutes' },
      { label: '60 Minutes', value: '1 hour' },
      { label: '120 Minutes', value: '2 hour' },
    ];
    return unpaidBreak;
  };

export const unpaidBreakMapping = {
  0: 'No',
  15: '15 Minutes',
  30: '30 Minutes',
  45: '45 Minutes',
  60: '1 Hour',
  120: '2 Hour'
}

export const getShiftMode = (shiftType: string): string =>
    ({ 'All': 'single', 'false': 'multiple', 'true': 'recurrent' }[shiftType] || 'single');

export const getAvailableExperienceOptions = (): Array<{ label: string, value: number }> => {
  const options: Array<{ label: string, value: number }> = [];
  for (let i = 1; i <= 12; i++) {
    options.push({ label: `${i} Month${i !== 1 ? 's' : ''}`, value: i });
  }
  for (let i = 2; i <= 20; i++) {
    options.push({ label: `${i} Year${i !== 1 ? 's' : ''}`, value: i * 12 });
  }
  return options;
};
